module.exports = __webpack_public_path__ + "media/images/_mySweetWed_logo-b2736de515f0dfef0a73193bd8d68168.svg";